import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  pillsWrapper: FelaCSS;
  pill: FelaCSS;
}

const styles = ({ compactMode }: { compactMode: boolean }): IStyles => ({
  wrapper: {
    marginTop: '10px',
    marginBottom: compactMode ? '16px' : '10px',
    marginLeft: compactMode ? '16px' : 0,

    maxWidthMobile: {
      borderTopWidth: 0,
    },
  },

  pillsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 4,
    justifyContent: 'left',
  },

  pill: {
    border: `1px solid ${colors.space40}`,
    fontDefaultSemiBold: 16,
    lineHeight: '24px',
    color: colors.space75,
    paddingHorizontal: 4,
    backgroundColor: colors.white,
    cursor: 'pointer',

    ':hover': {
      backgroundColor: colors.blueCrush30,
    },
  },
});

export default styles;
